import React, { useCallback, useContext } from 'react';
import { DayPicker } from '@components/pickers/day-picker';
import { CalendarContext } from '../../calendar-context';
import { getScaleLabel } from '../../utils';

export function CalendarDayPicker() {
  const { currentDate, setCurrentDate, settings, dataSource } =
    useContext(CalendarContext);

  const handleChange = useCallback(
    (value: number) => {
      setCurrentDate(value);
      dataSource.yAxis.refreshData();
    },
    [dataSource.yAxis, setCurrentDate]
  );

  return (
    <DayPicker
      labelMapper={(d) => getScaleLabel(d, settings, [])}
      currentDate={currentDate}
      onChange={handleChange}
    />
  );
}
